import React from 'react';
import styled from 'styled-components';
import ClientTableRow from 'containers/CompanyContainer/ClientTableRow';
import CompanyPageButton from 'containers/CompanyContainer/CompanyPageButton';

const BookingTableContainer = styled.div`
    padding: 3%;
`

class ClientTable extends React.Component {
    render(){
        const { clients, onClick, buttonText } = this.props;
        return (
            <BookingTableContainer>
                {/* <ClientTableRow 
                    actions={null} 
                    values={[null]} 
                    type={'header'} 
                /> */}
                { clients && Object.keys(clients).map( (client, index) => {
                        let clientName = `${clients[client].basicProfile.firstName} ${clients[client].basicProfile.lastName}`;
                        let selectedClient = clients[client];
                        let nextWizardStep = 1;
                        return <ClientTableRow 
                            key={`client${index}`}
                            actions={[<CompanyPageButton
                                key={index} 
                                type='dark' 
                                size='small' 
                                style={{width: "fit-content"}}
                                children={buttonText}
                                onClick={() => onClick(selectedClient, nextWizardStep)}
                            />]}
                            values = {[clientName]}
                            type = {'row'}
                        />
                })}
            </BookingTableContainer>
        )
    }
}

export default ClientTable;


// WEBPACK FOOTER //
// ./src/js/containers/CompanyContainer/ClientTable.jsx